import React from 'react';
import { RMA_STAGE, TONE, stageOf, isOverdue, daysOverSla } from './rmaHelpers';

// Stage pill with a leading dot, plus a separate overdue pill when the RMA has been with
// the manufacturer longer than its SLA.
//
// Overdue is deliberately a SECOND pill rather than a different stage colour: the unit is
// still "with manufacturer", and being late is a fact about elapsed time, not a new state.
function RmaStagePill({ shipment, showOverdue = true, settings, now = Date.now() }) {
  const stage = RMA_STAGE[stageOf(shipment)];
  if (!stage) return null;
  const tone = TONE[stage.tone] || TONE.neutral;
  const late = showOverdue && isOverdue(shipment, now, settings);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <span
        className={'pill ' + tone.pill}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 5, whiteSpace: 'nowrap' }}
      >
        <span style={{ width: 6, height: 6, borderRadius: '50%', background: tone.text, flexShrink: 0 }} />
        {stage.label}
      </span>
      {late && (
        <span className="pill pill-danger" style={{ whiteSpace: 'nowrap' }}>
          {daysOverSla(shipment, now, settings)}d over
        </span>
      )}
    </span>
  );
}

export default RmaStagePill;
